// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDIeMtql0x2mdu0CM0CjxjQuXmkzw9xzJI",
    authDomain: "coin-bot-go.firebaseapp.com",
    databaseURL: "https://coin-bot-go.firebaseio.com",
    projectId: "coin-bot-go",
    storageBucket: "coin-bot-go.appspot.com",
    messagingSenderId: "190836784247"
  }
};



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/environments/environment.ts